import { render } from "./userAsking2.vue?vue&type=template&id=5d8756f0&scoped=true"
import script from "./userAsking2.vue?vue&type=script&lang=js"
export * from "./userAsking2.vue?vue&type=script&lang=js"

import "./assets/common.css?vue&type=style&index=0&lang=css&external"
import "./assets/index.abs.css?vue&type=style&index=1&id=5d8756f0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8756f0"]])

export default __exports__